var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.264,
    height: 18.094,
    viewBox: "0 0 14.264 18.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload_photo",
    "data-name": "Upload photo",
    transform: "translate(-948.868 -1563.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-outline",
    transform: "translate(949.618 1564.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M105.573,176h1.6a1.533,1.533,0,0,1,1.6,1.463v7.605a1.533,1.533,0,0,1-1.6,1.463H97.6a1.533,1.533,0,0,1-1.6-1.463v-7.605A1.533,1.533,0,0,1,97.6,176h1.6",
    transform: "translate(-96 -169.937)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M176,51.191,179.191,48l3.191,3.191m-3.191,8.935V48.638",
    transform: "translate(-172.809 -48)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.823759be9b3b04d57bfb7131cef68c5a.svg";
export { ForwardRef as ReactComponent };